export default __webpack_public_path__ + "7be2eca7f897d7ab51c1de2a3338b0e7.svg";